import { Question, X } from '@phosphor-icons/react';
import { useState } from 'react';

interface InfoIconProps {
  title: string;
  content: string;
}

export default function InfoIcon({ title, content }: InfoIconProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        className="inline-flex items-center justify-center w-5 h-5 ml-1 text-text-secondary hover:text-primary transition-colors"
        aria-label="More information"
      >
        <Question size={16} weight="bold" />
      </button>

      {/* Modal */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" 
          onClick={handleBackdropClick}
        >
          <div 
            className="bg-input-bg border border-border-light rounded-lg p-4 max-w-sm w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-start mb-3">
              <h3 className="text-white text-base font-semibold">{title}</h3>
              <button
                type="button"
                onClick={handleClose}
                className="text-text-secondary hover:text-white transition-colors flex-shrink-0"
                aria-label="Close"
              >
                <X size={20} />
              </button>
            </div>
            <p className="text-text-secondary text-sm leading-relaxed">
              {content}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
